import React from 'react'
import "./Navbar.css"
import data from './data'
import moredark1 from '../../assets/logo4.jpg'
import {IoIosColorPalette} from "react-icons/io"
import {GiHamburgerMenu} from "react-icons/gi"




import ColorItem from './color-item';
import { useEffect,useState } from 'react'



const Navbar = () => {
  const colors=['#4db5ff','#4834d4','#be2edd','#0cf21b','#6ab04c','#f2680c'];
  const [state,setState]=useState(false);

  const [menu, setMenu] = useState(false);
 

  useEffect(()=>{
    const currentColor=localStorage.getItem('color')
    setTheme(currentColor)
    
  },[])

  const setTheme=(color)=>{
    document.documentElement.style.setProperty('--color-primary',color)
  }

  const setColor=(event)=>{
    const currentColor=event.target.style.getPropertyValue('--color-primary')
    setTheme(currentColor)
    localStorage.setItem('color',currentColor)

  }
  

  return (
    <nav>
       <div className='container nav_container'>
  <a href=" index.html" className='nav_logo'>
    <img src={moredark1} alt="Logo" />
  </a>
  <ul className={menu? "nav_menu-mobile":"nav_menu"}
  onClick={()=>setMenu(false)}>
 {
  data.map(item=><li key={item.id}>
    <a href={item.link} >{item.title}</a>
  </li>)
 }
 <li>
  <a href="https://drive.google.com/uc?export=download&id=1giMIqhzTMpIwHhyw1a8erKHpxeRfOuZr" 
     onClick={() =>
      window.open(
        "https://drive.google.com/file/d/1giMIqhzTMpIwHhyw1a8erKHpxeRfOuZr/view?usp=share_link",
        "_blank"
      )
    }
>Resume</a>
 </li>

 

  </ul>
  

  <div className={`color-switcher ${state && 'color-switcher--open' }`}>
  <button className='theme_icon' onClick={()=>setState(prevState =>!prevState)}><IoIosColorPalette/></button>
        <h1 className='heading'> Select Color</h1>
        <div className='color-list'>
          {colors.map((color,idx)=><ColorItem key={idx} setColor={setColor} color={color}/>)}
        </div>

      </div>
      <button className='mobile-menu-icon'
      onClick={()=>setMenu(!menu)}>
  {menu ? (
  <GiHamburgerMenu/>
      ) :( 
  
        <GiHamburgerMenu/>
      
    

  )}
  
</button>


 </div>

    </nav>

  )
}

export default Navbar